import { NavigateFn } from '@tanstack/react-router'
import { useEffect } from 'react'

import { SetFilterValuePropTypes } from './filterTypes'

export const removeFilter = (
  column: {
    setFilterValue: (value: SetFilterValuePropTypes) => void
    id: string
  },
  setActiveFilters: React.Dispatch<React.SetStateAction<string[]>>,
  navigate: NavigateFn
) => {
  // First update the URL to remove the filter
  navigate({
    to: '.',
    search: (prev) => ({
      ...prev,
      [column.id]: undefined,
    }),
  })

  // Then update the column filter value
  column.setFilterValue(undefined)

  // Finally update the active filters state
  setActiveFilters((filters) => filters.filter((f) => f !== column.id))
}

export const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  handler: () => void
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }
      handler()
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}

export const normalizeString = (str: string) => {
  return str.toLowerCase().trim()
}

export const getSortedUniqueValues = (column: {
  getFacetedUniqueValues: () => Map<string, number>
}) => {
  const facetedValues = column.getFacetedUniqueValues()
  const allValues = new Set<string>()

  for (const key of facetedValues.keys()) {
    if (Array.isArray(key)) {
      key.forEach((item) => {
        if (typeof item === 'string') {
          allValues.add(item)
        }
      })
    } else if (typeof key === 'string') {
      allValues.add(key)
    }
  }

  return Array.from(allValues).sort()
}
